"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SerialFirmwareUpdateT = exports.SerialFirmwareUpdate = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const firmware_part_js_1 = require("../../solarxr-protocol/rpc/firmware-part.js");
const serial_device_port_js_1 = require("../../solarxr-protocol/rpc/serial-device-port.js");
class SerialFirmwareUpdate {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsSerialFirmwareUpdate(bb, obj) {
        return (obj || new SerialFirmwareUpdate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsSerialFirmwareUpdate(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new SerialFirmwareUpdate()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    /**
     * id of the device, this refer to a serial port id
     */
    deviceId(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new serial_device_port_js_1.SerialDevicePort()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    /**
     * Will make the server ask for the tracker to be manually rebooted by the user
     * after the tracker is done flashing
     */
    needManualReboot() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    ssid(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    password(optionalEncoding) {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? this.bb.__string(this.bb_pos + offset, optionalEncoding) : null;
    }
    /**
     * A list of urls and offsets of the different firmware files to flash
     */
    firmwarePart(index, obj) {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? (obj || new firmware_part_js_1.FirmwarePart()).__init(this.bb.__indirect(this.bb.__vector(this.bb_pos + offset) + index * 4), this.bb) : null;
    }
    firmwarePartLength() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? this.bb.__vector_len(this.bb_pos + offset) : 0;
    }
    static startSerialFirmwareUpdate(builder) {
        builder.startObject(5);
    }
    static addDeviceId(builder, deviceIdOffset) {
        builder.addFieldOffset(0, deviceIdOffset, 0);
    }
    static addNeedManualReboot(builder, needManualReboot) {
        builder.addFieldInt8(1, +needManualReboot, +false);
    }
    static addSsid(builder, ssidOffset) {
        builder.addFieldOffset(2, ssidOffset, 0);
    }
    static addPassword(builder, passwordOffset) {
        builder.addFieldOffset(3, passwordOffset, 0);
    }
    static addFirmwarePart(builder, firmwarePartOffset) {
        builder.addFieldOffset(4, firmwarePartOffset, 0);
    }
    static createFirmwarePartVector(builder, data) {
        builder.startVector(4, data.length, 4);
        for (let i = data.length - 1; i >= 0; i--) {
            builder.addOffset(data[i]);
        }
        return builder.endVector();
    }
    static startFirmwarePartVector(builder, numElems) {
        builder.startVector(4, numElems, 4);
    }
    static endSerialFirmwareUpdate(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createSerialFirmwareUpdate(builder, deviceIdOffset, needManualReboot, ssidOffset, passwordOffset, firmwarePartOffset) {
        SerialFirmwareUpdate.startSerialFirmwareUpdate(builder);
        SerialFirmwareUpdate.addDeviceId(builder, deviceIdOffset);
        SerialFirmwareUpdate.addNeedManualReboot(builder, needManualReboot);
        SerialFirmwareUpdate.addSsid(builder, ssidOffset);
        SerialFirmwareUpdate.addPassword(builder, passwordOffset);
        SerialFirmwareUpdate.addFirmwarePart(builder, firmwarePartOffset);
        return SerialFirmwareUpdate.endSerialFirmwareUpdate(builder);
    }
    unpack() {
        return new SerialFirmwareUpdateT((this.deviceId() !== null ? this.deviceId().unpack() : null), this.needManualReboot(), this.ssid(), this.password(), this.bb.createObjList(this.firmwarePart.bind(this), this.firmwarePartLength()));
    }
    unpackTo(_o) {
        _o.deviceId = (this.deviceId() !== null ? this.deviceId().unpack() : null);
        _o.needManualReboot = this.needManualReboot();
        _o.ssid = this.ssid();
        _o.password = this.password();
        _o.firmwarePart = this.bb.createObjList(this.firmwarePart.bind(this), this.firmwarePartLength());
    }
}
exports.SerialFirmwareUpdate = SerialFirmwareUpdate;
class SerialFirmwareUpdateT {
    constructor(deviceId = null, needManualReboot = false, ssid = null, password = null, firmwarePart = []) {
        this.deviceId = deviceId;
        this.needManualReboot = needManualReboot;
        this.ssid = ssid;
        this.password = password;
        this.firmwarePart = firmwarePart;
    }
    pack(builder) {
        const deviceId = (this.deviceId !== null ? this.deviceId.pack(builder) : 0);
        const ssid = (this.ssid !== null ? builder.createString(this.ssid) : 0);
        const password = (this.password !== null ? builder.createString(this.password) : 0);
        const firmwarePart = SerialFirmwareUpdate.createFirmwarePartVector(builder, builder.createObjectOffsetList(this.firmwarePart));
        return SerialFirmwareUpdate.createSerialFirmwareUpdate(builder, deviceId, this.needManualReboot, ssid, password, firmwarePart);
    }
}
exports.SerialFirmwareUpdateT = SerialFirmwareUpdateT;
